'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Icon = require('../Icon-deabd942.js');
var React = _interopDefault(require('react'));
require('@carbon/icon-helpers');
require('prop-types');

var WarningFilled16 =
/*#__PURE__*/
React.forwardRef(function WarningFilled16(props, ref) {
  return React.createElement(Icon.Icon, Icon._extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), React.createElement("path", {
    d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
  }), React.createElement("path", {
    d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
    "data-icon-path": "inner-path",
    opacity: "0"
  }), props.children);
});

module.exports = WarningFilled16;
